<template>
  <div class="page-template" v-loading="loading">
    <!--    <menu-list></menu-list>-->
    <el-tabs v-model="activeTab" @tab-click="tabChange">
      <el-tab-pane label="导购员提成明细" name="salsDetail">
        <search-form-template
          :searchOptions="searchOptionsDetail"
          :toolConfig="toolConfig"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          @btnCommon="exportExcelSalsDetail()"
        ></search-form-template>
        <table-template ref="salsDetail" :tableOptions="salsDetail"></table-template>
      </el-tab-pane>
      <el-tab-pane label="导购员提成汇总" name="salsSum">
        <search-form-template
          :searchOptions="searchOptionsSum"
          :toolConfig="toolConfig"
          @searchSubmit="searchSubmitSum"
          @clear="clearSearch"
          @btnCommon="exportExcelSalsSum()"
        ></search-form-template>
        <table-template ref="salsSum" :tableOptions="salsSum"></table-template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import searchFormTemplate from '@/components/template/searchFormTemplate';
  import tableTemplate from '@/components/template/tableTemplate';
  import api from '@/config/api';
  import userPower from '@/mixin/userPower'

  export default {
    mixins: [userPower],
    name: 'RoleManager',
    components: {
      tableTemplate,
      searchFormTemplate,
    },
    data() {
      return {
        salsDetailData: [],
        activeTab: 'salsDetail',
        loading: false,
        // 更多功能
        toolConfig: [

          {
            label: '导出',
            code: 'export',
            callback: this.exportExcelData
          }
        ],
        //导购员提成汇总 高级搜索条件
        searchOptionsSum: {
          simple: [
            // {
            //   label: '导购员',
            //   prop: 'guideId',
            //   type: 'select',
            //   labelWidth:'60px',
            //   data: [],
            //   url: api.system.guide,
            // },
          ],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              span: 24
            },
            {
              label: '门店',
              type: 'select',
              prop: 'storeId',
              span: 6,
              data: [],
              isHasAll: true,
              url: api.store.store,
              change: this.sumChangeStore
            },
            {
              label: '导购员',
              prop: 'guideId',
              type: 'select',
              span: 6,
              data: [],
              // url: api.system.guide,
            },
            {
              label: '是否统计0提成商品',
              labelWidth: '150px',
              type: 'select',
              prop: 'zeroCommission',
              span: 12,
              defaultValue: 10,
              data: [{name: '是', id: 10}, {name: '否', id: 20}],
            }
          ]
        },
        //导购员提成明细 高级搜索条件
        searchOptionsDetail: {
          labelWidth: '150px',

          simple: [
            {
              label: '票号',
              prop: 'orderNo',
              type: 'input',
              labelWidth: '60px',
              isFuzzy: true, // 是否支持模糊搜索
              placeholder: '请输入票号'
            }],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              span: 24
            },
            {
              label: '门店',
              type: 'select',
              prop: 'storeId',
              span: 8,
              isHasAll: true,
              data: [],
              url: api.store.store,
              change: this.detailChangeStore
            },
            {
              label: '导购员',
              prop: 'guideId',
              type: 'select',
              span: 8,
              data: [],
              // url: api.system.guide,
            },
            {
              label: '条码',
              prop: 'barCode',
              type: 'input',
              span: 8,
              placeholder: '请输入条码'
            },
            {
              label: '类别',
              type: 'cascaderMultiple',
              prop: 'goodsCategoryIds',
              valueKey: 'value',
              data: [],
              span: 8,
              url: api.archives.getCategoryTree,
            },
            {
              label: '品牌',
              prop: 'brandId',
              type: 'select',
              span: 8,
              data: [],
              // url: api.archives.brand,
            },
            {
              label: '是否统计0提成商品',
              type: 'select',
              prop: 'zeroCommission',
              span: 8,
              defaultValue: 10,
              data: [{name: '是', id: 10}, {name: '否', id: 20}],
            },
            // {
            //   label:' ',
            //   type: 'checkbox',
            //   name:'是否统计0提成商品',
            //   span:12,
            //   labelWidth:'100px',
            //   data: [{name:'是',id:10},{name:'否',id:20}],
            //   prop:'zeroCommission',
            //   defaultValue:10,
            // }
          ]
        },
        // 导购员提成明细
        salsDetail: {
          showSummary: true,
          summaryColumns: ['goodsNum', 'payPrice', 'commissionPrice'],
          menuListHidden: "hidden",//是否隐藏menuList
          indexShow: true,//是否显示索引
          columns: [
            {
              label: '门店',
              prop: 'storeName',
              width: '150',
              align: 'center'
            },
            {
              label: '导购员',
              prop: 'guideName',
              width: '100',
              align: 'center'
            },
            {
              label: '票号',
              prop: 'orderNo',
              width: '220',
              align: 'center'
            },
            {
              label: '销售时间',
              prop: 'lastModifyDttm',
              width: '150',
              align: 'center'
            },
            {
              label: '条码',
              prop: 'barCode',
              width: '150',
              align: 'center'
            },
            {
              label: '品名',
              prop: 'goodsName',
              width: '150',
              align: 'center'
            },
            {
              label: '规格',
              prop: 'specs',
              width: '70',
              align: 'center'
            },
            {
              label: '单位',
              prop: 'unitName',
              width: '70',
              align: 'center'
            },
            {
              label: '类别',
              prop: 'goodsCategoryName',
              width: '90',
              align: 'center'
            },
            // {
            //   label: '交易方式',
            //   prop: 'payType',
            //   width: '120',
            //   align: 'center',
            //   enumData: this.$utils.getCacheStatus('soBillOrderPay.payType'),
            // },
            {
              label: '销售单价',
              prop: 'unitPrice',
              width: '120',
              align: 'center'
            },
            {
              label: '销售数量',
              prop: 'goodsNum',
              width: '120',
              align: 'center'
            },
            {
              label: '销售金额',
              prop: 'payPrice',
              width: '120',
              align: 'center'
            },
            {
              label: '提成金额',
              prop: 'commissionPrice',
              width: '120',
              align: 'center'
            },
          ],
          url: api.report.commissionDetail
        },
        // 导购员提成汇总
        salsSum: {
          showSummary: true,
          summaryColumns: ['goodsNum', 'payPrice', 'commissionPrice'],
          indexShow: true,//是否显示索引
          columns: [
            {
              label: '门店',
              prop: 'storeName',
              width: '190',
              align: 'center'
            },
            {
              label: '导购员',
              prop: 'guideName',
              width: '150',
              align: 'center'
            },
            {
              label: '销售数量',
              prop: 'goodsNum',
              width: '120',
              align: 'center'
            },
            {
              label: '销售金额',
              prop: 'payPrice',
              width: '120',
              align: 'center'
            },
            {
              label: '提成金额',
              prop: 'commissionPrice',
              width: '120',
              align: 'center'
            },
          ],
          url: api.report.commissionSummary
        },
      };
    },
    created() {
      this.title = document.title;
      this.setStore(this.searchOptionsDetail.complex);
      this.setStore(this.searchOptionsSum.complex);
      this.getBrandGuid()
    },
    mounted() {
    },
    methods: {
      getBrandGuid(storeId) {
        let userInfo = this.$utils.getSysUser();
        if (userInfo.storeId) {
          this.$axios.fetchPost(api.archives.brand + '/query/brand/list', {storeId: storeId}).then(data => {
            if (data.code === 200) {
              this.searchOptionsDetail.complex.filter(item => item.prop === 'brandId')[0].data = data.data;
            }
          });
          this.$axios.fetchPost(api.system.guide + '/list', {storeId: storeId, type: 50}).then(data => {
            if (data.code === 200) {
              this.searchOptionsDetail.complex.filter(item => item.prop === 'guideId')[0].data = data.data;
              this.searchOptionsSum.complex.filter(item => item.prop === 'guideId')[0].data = data.data;
            }
          });
        }
      },
      // 明细选择门店
      detailChangeStore(form) {
        form.brandId = '';
        form.guideId = '';
        this.$axios.fetchPost(api.archives.brand + '/query/brand/list', {storeId: form.storeId}).then(data => {
          if (data.code === 200) {
            this.searchOptionsDetail.complex.filter(item => item.prop === 'brandId')[0].data = data.data;
          }
        });
        this.$axios.fetchPost(api.system.guide + '/list', {storeId: form.storeId, type: 50}).then(data => {
          if (data.code === 200) {
            this.searchOptionsDetail.complex.filter(item => item.prop === 'guideId')[0].data = data.data;
          }
        });
      },
      // 汇总选择门店
      sumChangeStore(form) {
        form.guideId = '';
        this.$axios.fetchPost(api.system.guide + '/list', {storeId: form.storeId, type: 50}).then(data => {
          if (data.code === 200) {
            this.searchOptionsSum.complex.filter(item => item.prop === 'guideId')[0].data = data.data;
          }
        });
      },
      searchSubmit(param) {
        this.$refs[this.activeTab].searchParam = param;
        this.$refs[this.activeTab].operationSuccess();
      },
      tabChange(val) {
        this.$refs[this.activeTab].operationSuccess();
      },
      clearSearch() {
        this.$refs['salsDetail'].clearSearch();
        this.$refs['salsSum'].clearSearch();
        let userInfo = this.$utils.getSysUser();
        if (!userInfo.storeId) {
          this.searchOptionsDetail.complex.filter(item => item.prop === 'brandId')[0].data = [];
          this.searchOptionsSum.complex.filter(item => item.prop === 'guideId')[0].data = [];
        }
      },
      // 导购员提成汇总
      searchSubmitSum(param) {
        this.$refs[this.activeTab].searchParam = param;
        this.$refs[this.activeTab].operationSuccess();
      },
      exportExcelSalsDetail() {
        const loading = this.$loading({
          lock: true,
          text: '正在导出...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        let param = this.$refs["salsDetail"].searchParam;
        this.$axios.PostBlob(api.report.commissionDetailExport, param).then(res => {
          if (res.status === 200) {
            const fileName = '导购员提成明细_' + this.$utils.getDateTime() + ".xlsx";
            let blob = new Blob([res.data])
            let downloadElement = document.createElement('a');
            let href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
            this.$notify({
              type: "success",
              title: '导出操作',
              message: '成功!文件名称:' + fileName,
              showClose: false,
            });
            // this.$message.success("导出成功,文件名称:" + fileName);
          } else {
            this.$notify({
              type: "error",
              title: '导出操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.error("导出失败,请稍后再试");
          }
        }).catch(() => {
          this.$message.warning("当前导出数据为空或超出10000条。");
        }).finally(() => {
          loading.close();
        });
      },
      exportExcelSalsSum() {
        const loading = this.$loading({
          lock: true,
          text: '正在导出...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        let param = this.$refs["salsSum"].searchParam;
        this.$axios.PostBlob(api.report.commissionSummaryExport, param).then(res => {
          if (res.status === 200) {
            const fileName = '导购员提成汇总_' + this.$utils.getDateTime() + ".xlsx";
            let blob = new Blob([res.data])
            let downloadElement = document.createElement('a');
            let href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
            this.$notify({
              type: "success",
              title: '导出操作',
              message: '成功!文件名称:' + fileName,
              showClose: false,
            });
            // this.$message.success("导出成功,文件名称:" + fileName);
          } else {
            this.$notify({
              type: "error",
              title: '导出操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.error("导出失败,请稍后再试");
          }
        }).catch(() => {
          this.$message.warning("当前导出数据为空或超出10000条。");
        }).finally(() => {
          loading.close();
        });
      },
    }
  }
</script>

<style scoped>
  >>> .el-tabs__header {
    margin: 0 0 5px;
  }

  .page-template {
    padding-top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/page/retail/query/Sales.vue